'use client';

import Link from 'next/link';
import Button from '@mui/material/Button';

type Props = {
  href?: string;
  as?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

const MaterialLinkButton = ({ href, as, children, ...props }: Props) => (
  <Button component={Link} href={as || href} {...props}>
    {children}
  </Button>
);

export default MaterialLinkButton;
